export const sliderItemsHome = [
{  
    id:1,
    img:"https://cdn.junipercreates.com/apexlegends/images/Anniversary%20Launch%20-%20Desktop_1644548559299.jpg"
},

{
    id:2,
    img:"https://cdn.junipercreates.com/apexlegends/images/S12%20Banner%20-%20Mobile_1644548545063.jpg"
},

{
    id:3,
    img:"https://cdn.junipercreates.com/apexlegends/images/Collectibles%20-%20Mobile_1644548575802.jpg"
},
]    
